import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Params, Router } from '@angular/router';
import { EventTrackerInterface } from '@commons/tracker/event-tracker/event-tracker.interface';
import { EventTrackerService } from '@commons/tracker/event-tracker/event-tracker.service';
import { JobRoutingEnum } from '@features/routing/job/job-routing.enum';
import { Job } from '@models/job/job';
import { Bookmark } from '@models/profile/bookmark';

@Component({
  selector: 'app-mini',
  templateUrl: './mini.component.html',
  styleUrls: ['./mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniComponent {
  JobRoutingEnum = JobRoutingEnum;
  @Input() model: Job;
  @Input() queryParams: Params;
  @Input() queryParamsHandling: 'merge' | 'preserve' | '';
  @Input() bookmark: Bookmark;
  @Input() logged = true;
  @Input() addStructuredData: boolean;
  @Input() showCompany: boolean;
  @Input() trackingData: EventTrackerInterface;

  @Output() toggleBookmark = new EventEmitter<Bookmark>();

  constructor(private readonly router: Router, private readonly eventWebservice: EventTrackerService) {}

  @HostListener('click', ['$event.target'])
  doVisitJob(target: any): void {
    if (['A', 'BUTTON'].indexOf(target.tagName) !== -1) {
      return;
    }

    this.eventWebservice.send(this.trackingData);
    this.router.navigate([JobRoutingEnum.Company, this.model.company.id, JobRoutingEnum.Job, this.model.id], {
      queryParams: this.queryParams,
      queryParamsHandling: this.queryParamsHandling,
      fragment: 'layout-main',
    });
  }
}
